module.exports = __webpack_public_path__ + "img/cp-ad-t.3bec6160.png";